import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PermissionCheckDirective } from './directives/permission-check.directive';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatAutocompleteModule } from '@angular/material';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastrModule, ToastContainerModule } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { SelectableRoleListComponent } from './components/selectable-role-list/selectable-role-list.component';
import { MedicalCenterAutocompleteComponent } from './components/medical-center-autocomplete/medical-center-autocomplete.component';
import { MedicalUserAutocompleteComponent } from './components/medical-user-autocomplete/medical-user-autocomplete.component';
import { AbstractCustomControlComponent } from './components/abstract-custom-control/abstract-custom-control.component';
import { AbstractNestedFormComponent } from './components/abstract-nested-form/abstract-nested-form.component';
import { PatientShortDetailComponent } from './components/patient-short-detail/patient-short-detail.component';
import { CollapsibleFieldsetComponent } from './components/collapsible-fieldset/collapsible-fieldset.component';
import { MedicalCenterExportComponent } from './components/medical-center-export/medical-center-export.component';
import { MedicalCenterStatisticsComponent } from './components/medical-center-statistics/medical-center-statistics.component';
import { SortToggleComponent } from './components/sort-toggle/sort-toggle.component';
import { PageSizeSelectorComponent } from './components/page-size-selector/page-size-selector.component';
import { ShrinkCodePipe } from '../pipes/shrink-code.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComuneAutocompleteComponent } from './components/comune-autocomplete/comune-autocomplete.component';
import { ProvinciaAutocompleteComponent } from './components/provincia-autocomplete/provincia-autocomplete.component';


@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        TooltipModule.forRoot(),
    ],
    declarations: [
        PermissionCheckDirective,
        ConfirmModalComponent,
        HeaderComponent,
        SelectableRoleListComponent,
        MedicalCenterAutocompleteComponent,
        MedicalUserAutocompleteComponent,
        AbstractCustomControlComponent,
        AbstractNestedFormComponent,
        PatientShortDetailComponent,
        CollapsibleFieldsetComponent,
        MedicalCenterExportComponent,
        MedicalCenterStatisticsComponent,
        SortToggleComponent,
        PageSizeSelectorComponent,
        ShrinkCodePipe,
        ComuneAutocompleteComponent,
        ProvinciaAutocompleteComponent
    ],
    exports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        PermissionCheckDirective,
        MatDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        TooltipModule,
        ToastrModule,
        ToastContainerModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        ConfirmModalComponent,
        HeaderComponent,
        SelectableRoleListComponent,
        AbstractCustomControlComponent,
        AbstractNestedFormComponent,
        MedicalCenterAutocompleteComponent,
        MedicalUserAutocompleteComponent,
        PatientShortDetailComponent,
        CollapsibleFieldsetComponent,
        MedicalCenterExportComponent,
        MedicalCenterStatisticsComponent,
        SortToggleComponent,
        PageSizeSelectorComponent,
        ShrinkCodePipe,
        MatTooltipModule,
        ComuneAutocompleteComponent,
        ProvinciaAutocompleteComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: ['l', 'LL'],
                },
                display: {
                    dateInput: 'L',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            },
        },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: {
                useUtc: true,
                strict: true,
            }
        }
    ],
    entryComponents: [
        ConfirmModalComponent
    ]
})

export class SharedModule { }
